import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * all the variables you can find in https://primeng.org/{component} theming tab
 */
export const APP_PRIME_PRESET = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: 'var(--app-color-primary)'
        },
        highlight: {
          background: '#EFF6FF',
          focusBackground: 'rgba(var(--app-color-secondary-rgb), .24)',
          color: 'var(--app-color-secondary)',
        },
      }
    }
  },
  components: {
    button: {},
    checkbox: {
      root: {
        width: '20px',
        height: '20px',
        background: 'var(--app-color-white)',
        checkedBackground: 'var(--app-color-white)',
        checkedHoverBackground: 'var(--app-color-white)',
      },
      icon: {
        checkedColor: 'var(--app-color-primary)',
        checkedHoverColor: 'var(--app-color-primary)',
      },
    },
    multiselect: {
      option: {
        selectedBackground: 'transparent',
        selectedFocusBackground: 'transparent'
      }
    },
    listbox: {
      list: {
        gap: 0
      }
    },
    fileupload: {
      header: {
        padding: 0,
        border: {
          radius: 0
        }
      }
    }
  }
});

